<button class="close" mat-button (click)="onNoClick()">X</button>

<ng-container>
  <div class="container aviso">  
    <div class="tituloSearch row">{{ 'TITULO_ENVIO_MAILS' | translate }}</div>
    <div class="row font-weight-bold text-centro">
      {{ 'SEPARADOR_MAILS' | translate }}
    </div>
    <form class="container avisoInputWrap mt-3" [formGroup]="mailsForm"> 
      <div class="row d-block">                 
      <textarea formControlName="mails" (focus)="focusValue($event)" category="TEXTAREA"
        class="form-control col-12" rows="7" cols="60" id="mails" [(ngModel)]="data.mails"></textarea>   
      </div> 
      <div *ngIf="showMsgError" class="text-center">
        <span class="msgError">{{ 'ERROR_MAILS' | translate }}</span>
      </div> 
      <div class="faturacion-fila row">
        <div class="ticket-info col-6">
          <div class="inputControl botones">
            <button type="button" value="cancelar" class="cancelar" (click)="onNoClick()">
              {{ 'CANCELAR' | translate }}
            </button>
          </div>
        </div>
        <div class="ticket-info col-6">
          <div class="inputControl botones">
            <button
              type="button"
              value="ACEPTAR"
              (click)="saveMails()"              
              class="pagar aceptar">
              {{ 'ACEPTAR' | translate }}
            </button>
          </div>
        </div>
      </div>            
    </form>
  </div>
<div class="keyboardWrap">  
  <ticketing-keyboard [mails]="true"></ticketing-keyboard>
  <ticketing-numpad></ticketing-numpad>
</div>
</ng-container>